import { z } from 'zod';
import { OrgFunctionSchema } from '../../entities/org-function/org-function.schema';
import { optionalEmailSchema } from '../../shared/email.schema';
import { ObjectIdSchema } from '../../shared/object-id.schema';
import { ErrorCode } from '../../shared/error-codes';
/**
 * Update OrgFunction Request Schema
 * PATCH /api/v2/orgFunction/:id
 *
 * All fields are optional (partial update). `kind` is deliberately absent:
 * converting a team into a role (or back) is not a product operation, and
 * keeping it immutable means authorization can rely on the stored kind.
 */ export const UpdateOrgFunctionRequestSchema = z.object({
    name: z.string().min(1, ErrorCode.FIELD_REQUIRED).optional(),
    // null = clear the stored email (server translates to $unset).
    email: optionalEmailSchema().nullable(),
    description: z.string().optional(),
    // null = clear the stored lead / department (server translates to $unset).
    lead: z.string().min(1, ErrorCode.FIELD_REQUIRED).nullable().optional(),
    department: z.string().min(1, ErrorCode.FIELD_REQUIRED).nullable().optional(),
    // Full desired set of users holding this OrgFunction as a secondary function.
    // Membership is never stored on the OrgFunction — the server reconciles each
    // user's `secondaryRoles` (adds missing links, removes deselected ones).
    // Absent = leave membership untouched. mainRole/lead links are unaffected.
    // Validated as 24-hex ObjectIds at the wire boundary so a malformed id is a
    // 400, not a Mongoose CastError that surfaces as a 500.
    members: z.array(ObjectIdSchema).optional()
});
/**
 * Update OrgFunction Response Schema
 * PATCH /api/v2/orgFunction/:id
 */ export const UpdateOrgFunctionResponseSchema = z.object({
    data: OrgFunctionSchema
});

//# sourceMappingURL=update-org-function.schema.js.map